import styled from "styled-components";

import { Carousel } from "../Carousel";

import { media } from "@otta/design";
import { pxToRem } from "@otta/design-tokens";

type Photo = {
  __typename: "CompanyBrandAsset";
  id: string;
  source: string;
  alt: string | null;
  small: string | null;
  medium: string | null;
  large: string | null;
};

const MobileOnly = styled.div`
  ${media({ from: "tablet" }, "screen")`
    display: none;
  `}
`;

const DesktopOnly = styled.div`
  ${media({ to: "tablet" }, "screen")`
    display: none;
  `}
`;

const MobileImageWrapper = styled.div`
  min-width: 100vw;
  margin: 2% 0;
  height: 100%;
  scroll-snap-align: center;
`;

const InnerImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ImageGrid = styled.div`
  ${media({ from: "tablet" })`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    gap: ${pxToRem(24)};
    grid-auto-rows: auto;
    grid-template-columns: 1fr 1fr;
  `}
`;

export const TwoPhotos = ({
  photos,
  section,
}: {
  photos: Photo[];
  section: string;
}) => {
  return (
    <div data-testid={`${section}-photos`}>
      <MobileOnly>
        <Carousel
          cards={photos.map((photo, idx) => (
            <MobileImageWrapper key={idx}>
              <InnerImg
                src={photo.source}
                srcSet={photo.small ?? undefined}
                alt={photo.alt || ""}
              />
            </MobileImageWrapper>
          ))}
          displayDots
        />
      </MobileOnly>
      <DesktopOnly>
        <ImageGrid>
          {photos.map((photo, idx) => (
            <div key={idx}>
              <InnerImg
                src={photo.source}
                srcSet={photo.small ?? undefined}
                alt={photo.alt || ""}
              />
            </div>
          ))}
        </ImageGrid>
      </DesktopOnly>
    </div>
  );
};
